import ChatIcon from '@mui/icons-material/Chat';

import { useI18n } from '@openclassrooms/translations/I18nProvider';
import { useLocalisationConfig } from '@openclassrooms/localisation/LocalisationConfigProvider';

import ContactChannelButton from './ContactChannelButton';

export default function ContactChannelExternalForm() {
  const { getLocalisationConfig } = useLocalisationConfig();
  const { translate } = useI18n();

  return (
    <ContactChannelButton
      iconComponent={ChatIcon}
      href={String(getLocalisationConfig('contact.genericForm.url'))}
    >
      {translate('support.global.contact_channel.help_center_contact.title')}
    </ContactChannelButton>
  );
}
